/* BSFA Fixes JS — logica dei singoli fix. */
(function () {
  'use strict';

  /* Helper i18n: legge da window.BSFA_I18N (iniettato da snippets/custom-code-head.liquid
     tramite le chiavi | t di locales/*.json) con fallback al tedesco originale. */
  function BSFA_t(path, fallback) {
    try {
      var parts = path.split('.');
      var obj = window.BSFA_I18N;
      for (var i = 0; i < parts.length; i++) {
        if (obj == null) break;
        obj = obj[parts[i]];
      }
      return (obj !== undefined && obj !== null && obj !== '') ? obj : fallback;
    } catch (e) { return fallback; }
  }

  /* Helper locale: restituisce il prefisso di root della lingua corrente
     (es. '' per la lingua predefinita, '/it' per l'italiano, ecc.), cosi'
     i link generati via JS non riportano mai l'utente al tedesco. */
  function BSFA_root() {
    try {
      var r = (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.root)
        || (window.BSFA_URLS && window.BSFA_URLS.root)
        || '/';
      return r === '/' ? '' : r.replace(/\/$/, '');
    } catch (e) { return ''; }
  }

  /* Tutte le lingue mai configurate nel tema (vedi locales/*.json), usate per
     riconoscere un prefisso di lingua "incollato" dentro l'URL di un link
     (es. una voce di menu di navigazione con un URL custom digitato a mano
     tipo "/it/collections/office", mostrato invariato a QUALSIASI visitatore
     indipendentemente dalla lingua che ha effettivamente selezionato). */
  var BSFA_KNOWN_LOCALES = ['de', 'en', 'es', 'fr', 'it', 'tr'];

  /* Rimuove un eventuale prefisso di lingua gia' presente in un path interno
     (es. "/it/collections/x" -> "/collections/x"), cosi' possiamo sempre
     ricalcolarlo sulla lingua che il visitatore ha davvero selezionato. */
  function BSFA_stripLocalePrefix(path) {
    var m = path.match(/^\/([a-z]{2})(\/.*|)$/i);
    if (m && BSFA_KNOWN_LOCALES.indexOf(m[1].toLowerCase()) !== -1) {
      return m[2] === '' ? '/' : m[2];
    }
    return path;
  }

  /* Safety net: qualunque link interno — sia quello "incollato" in un blocco
     HTML statico (dove Liquid non viene interpretato), sia una voce del menu
     di navigazione con un URL "custom" che ha la lingua sbagliata incollata
     dentro — viene ricalcolato sulla lingua correntemente selezionata dal
     visitatore, senza mai cambiare la destinazione (stessa collezione /
     pagina / prodotto). Prima veniva fatto solo quando prefix non era vuoto
     (cioe' mai per i visitatori sulla lingua predefinita), lasciando cosi'
     i link con un prefisso lingua sbagliato invariati anche per loro. */
  function BSFA_localizeLinks(scope) {
    try {
      var prefix = BSFA_root(); // '' per la lingua predefinita, '/en' ecc. altrimenti
      var root = scope || document;
      var allow = /^\/(collections|products|pages|blogs|policies|search|account|discount)(\/|$)|^\/$/;
      var links = root.querySelectorAll('a[href^="/"]:not([href^="//"])');
      links.forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href) return;
        if (/^https?:\/\//i.test(href)) return;
        var bare = BSFA_stripLocalePrefix(href);
        if (!allow.test(bare)) return; // non tocchiamo /cart, /checkout, /apps, ecc.
        var fixed = bare === '/' ? (prefix + '/') : (prefix + bare);
        if (fixed !== href) a.setAttribute('href', fixed);
      });
    } catch (e) {}
  }
  function BSFA_localizeLinksInit() { BSFA_localizeLinks(); }
  if (document.readyState !== 'loading') BSFA_localizeLinksInit();
  document.addEventListener('DOMContentLoaded', BSFA_localizeLinksInit);
  window.addEventListener('load', BSFA_localizeLinksInit);

  /* Pagina password/lock: non mostrare elementi commerciali (sale bar, popup) */
  function BSFA_isPwd(){
    try {
      if (document.body && /(^|\s)template-password(\s|$)/.test(document.body.className)) return true;
      if (/^\/password/.test(window.location.pathname)) return true;
      if (document.querySelector('.template-password, #password, form[action="/password"], form[action^="/password"]')) return true;
    } catch(e){}
    return false;
  }

  /* MOBILE — un tap su una voce di menu CON sottomenu (Microsoft Office,
     Windows, ...) NON deve portare alla collezione "prodotti misti": apre
     invece il sottomenu, come fa la freccia. Le voci senza sottomenu
     (Adobe, Entertainment, Bundle, Kontakt) restano link normali. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('#m-menu-drawer .m-menu-mobile__item > a');
    if (!link) return;
    var item = link.parentElement;
    var panel = item.querySelector(':scope > .m-megamenu-mobile');
    if (!panel) return;                 // nessun sottomenu -> link normale
    e.preventDefault();                 // niente navigazione alla collezione
    var toggle = item.querySelector(':scope > .m-menu-mobile__toggle-button');
    if (toggle) toggle.click();         // usa il toggle nativo del tema
  }, true);

  /* DESKTOP — chiusura mega menu */
  function bsfaIsDesktop() { return window.innerWidth >= 1024; }

  function bsfaCloseMega(hdr) {
    hdr.classList.add('bsfa-mega-closed');
    hdr.querySelectorAll('.m-menu__item--active').forEach(function (it) {
      it.classList.remove('m-menu__item--active');
    });
    document.documentElement.classList.remove('prevent-scroll');
  }

  document.addEventListener('click', function (e) {
    if (!bsfaIsDesktop()) return;
    var hdr = document.querySelector('.m-header__desktop');
    if (!hdr) return;
    if (e.target.closest('a')) return;
    bsfaCloseMega(hdr);
  }, true);

  function bsfaBindLeave() {
    var hdr = document.querySelector('.m-header__desktop');
    if (!hdr || hdr.__bsfaLeaveBound) return;
    hdr.__bsfaLeaveBound = true;
    hdr.addEventListener('mouseleave', function () {
      if (!bsfaIsDesktop()) return;
      bsfaCloseMega(hdr);
    });
  }
  bsfaBindLeave();
  document.addEventListener('DOMContentLoaded', bsfaBindLeave);
  window.addEventListener('load', bsfaBindLeave);

  document.addEventListener('mouseover', function (e) {
    if (!bsfaIsDesktop()) return;
    var hdr = document.querySelector('.m-header__desktop.bsfa-mega-closed');
    if (hdr && e.target.closest('.m-header__desktop .m-menu__item')) {
      hdr.classList.remove('bsfa-mega-closed');
    }
  }, true);

  /* ============================================================
     QUANTITA' > 10 — voce "Mehr als 10 …" nel menu quantità
     ============================================================ */
  function bsfaQtyEnhance() {
    document.querySelectorAll('select.bsfa-qty__select').forEach(function (s) {
      if (s.__bsfaMore) return;
      s.__bsfaMore = 1;
      var o = document.createElement('option');
      o.value = 'bsfa-more';
      o.textContent = BSFA_t('bulkHint.more_option', 'Mehr als 10 …');
      s.appendChild(o);
    });
  }
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || !s.classList || !s.classList.contains('bsfa-qty__select')) return;
    if (s.value !== 'bsfa-more') return;
    var inp = document.createElement('input');
    inp.type = 'number';
    inp.name = 'quantity';
    inp.min = '1';
    inp.step = '1';
    inp.value = '11';
    inp.setAttribute('aria-label', BSFA_t('qtyAria', 'Menge'));
    inp.className = 'm-quantity__input bsfa-qty__custom';
    s.parentNode.replaceChild(inp, s);
    inp.focus();
    try { inp.select(); } catch (err) {}
  }, true);

  /* Hint sconto quantità sotto i pulsanti di acquisto */
  function bsfaBulkHint() {
    if (document.getElementById('bsfa-bulk-hint')) return;
    var q = document.querySelector('.m-product-form--input .bsfa-qty, .m-product-form--input .m-quantity');
    if (!q) return;
    var wrap = q.closest('.m-product-form--wrapper') || q.closest('.m-product-form--input') || q;
    var d = document.createElement('div');
    d.id = 'bsfa-bulk-hint';
    d.innerHTML = BSFA_t('bulkHint.text_html', '💡 <b>Mengenrabatt:</b> Ab 10 Stück erhalten Sie automatisch <b>10% Rabatt</b> – zusätzlich <b>5%</b> mit Code <b>BULK5</b>.');
    wrap.insertAdjacentElement('afterend', d);
  }
  function bsfaQtyInit() { bsfaQtyEnhance(); bsfaBulkHint(); }
  if (document.readyState !== 'loading') bsfaQtyInit();
  document.addEventListener('DOMContentLoaded', bsfaQtyInit);
  window.addEventListener('load', bsfaQtyInit);
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('bsfa-qty__select')) bsfaQtyEnhance();
  }, true);


  /* ============================================================
     REVEAL-ON-SCROLL + stili globali iniettati
     ============================================================ */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var st = document.createElement('style');
    st.textContent = '.bsfa-will-reveal{opacity:0;transform:translateY(18px);transition:opacity .55s cubic-bezier(.22,.7,.3,1),transform .55s cubic-bezier(.22,.7,.3,1)}.bsfa-revealed{opacity:1 !important;transform:none !important}@media (prefers-reduced-motion: reduce){.bsfa-will-reveal{opacity:1;transform:none;transition:none}}.m-header .m-menu__item > .m-menu__link--main::before{display:inline-block !important;content:"" !important;margin-right:8px;vertical-align:-3px}.l4y-hero .l4y-slide-media--tile{position:relative}.l4y-hero .l4y-slide-media--tile img{background:transparent !important;border:0 !important;border-radius:0 !important;padding:0 !important;mix-blend-mode:multiply;position:relative;z-index:1;max-height:340px !important;max-width:82% !important;box-shadow:none !important;filter:saturate(1.06) contrast(1.02)}.l4y-hero .l4y-slide-media--tile::after{content:"";position:absolute;left:50%;bottom:4%;transform:translateX(-50%);width:58%;height:30px;background:radial-gradient(50% 50% at 50% 50%, rgba(15,40,80,.30), transparent 72%);border-radius:50%;z-index:0;pointer-events:none}.l4y-apps{display:flex !important;flex-wrap:wrap;gap:7px;justify-content:flex-start !important;margin:8px 0}.l4y-apps .l4y-app{display:inline-flex}.l4y-apps .l4y-app img{width:24px;height:24px;object-fit:contain;display:block}.l4y-card .l4y-apps,.m-main-product .l4y-apps,.m-product-info .l4y-apps{justify-content:flex-start !important;margin-left:0 !important;text-align:left}.l4y-price{color:#df0000 !important;font-weight:900 !important;font-style:italic;letter-spacing:-.01em}.l4y-card del{color:#878c93 !important;font-style:normal;font-size:13px}.l4y-card del::before{content:"UVP "}.l4y-badge{background:#df0000 !important;color:#fff !important;font-style:italic}.m-price .m-price-item--sale,.m-price__sale .m-price-item{color:#df0000 !important;font-weight:900 !important;font-style:italic}.m-price__sale s,.m-price s{color:#878c93 !important;font-weight:500 !important;font-style:normal}.m-price__sale s::before,.m-price s::before{content:"UVP "}.m-price__badge-sale,.m-badge--sale,.m-product-tag--sale{background:#df0000 !important;color:#fff !important;font-style:italic;font-weight:800}.l4y-collhero__logo img,.l4y-collhero__brand img{filter:none !important}.l4y-subcat--flat{margin-top:10px;padding-top:10px;border-top:1px solid #e6ecf3}.m-product-media .m-image{background:#fff !important}.m-product-media .m-image img{object-fit:contain !important}.m-product-media__thumbnail img,.m-product-media--thumbnail img{object-fit:contain !important;background:#fff}.m-product-description img,.m-rte img,.rte img,.prose img{max-width:100% !important;height:auto !important;display:block;margin-left:auto;margin-right:auto;border-radius:10px}.l4y-card img{object-fit:contain !important;background:#fff}@media (max-width:767px){.l4y-apps{gap:5px}.l4y-apps .l4y-app img{width:20px;height:20px}.m-product-media .m-image img{max-width:100% !important}.l4y-collhero{flex-wrap:wrap}body{overflow-x:clip}}.bsfa-salebar{position:relative;z-index:60;color:#fff;font-family:inherit;background:linear-gradient(100deg,#071b3e 0%,#0d2f6b 35%,#0a4da8 62%,#123a7c 100%);background-size:220% 220%;animation:bsfaSaleGrad 10s ease infinite;overflow:hidden}.bsfa-salebar::before{content:"";position:absolute;inset:0;background:radial-gradient(620px 90px at 18% 0%,rgba(10,132,255,.30),transparent 70%),radial-gradient(520px 90px at 86% 100%,rgba(247,103,7,.20),transparent 70%);pointer-events:none}.bsfa-salebar::after{content:"";position:absolute;top:0;bottom:0;width:30%;left:-40%;transform:skewX(-18deg);background:linear-gradient(105deg,transparent,rgba(255,255,255,.15),transparent);animation:bsfaSaleShine 5s linear infinite;pointer-events:none}@keyframes bsfaSaleGrad{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}@keyframes bsfaSaleShine{from{left:-45%}to{left:125%}}.bsfa-salebar__in{position:relative;z-index:1;max-width:1280px;margin:0 auto;display:flex;align-items:center;gap:16px;padding:9px 18px;flex-wrap:wrap;justify-content:center}.bsfa-salebar__tag{display:inline-flex;align-items:center;gap:7px;font-weight:900;font-size:13.5px;letter-spacing:.02em;white-space:nowrap;background:linear-gradient(135deg,#ff6a3d,#f43f5e);border-radius:999px;padding:6px 15px;box-shadow:0 4px 14px rgba(244,63,94,.42)}.bsfa-salebar__flame{font-style:normal;display:inline-block;animation:bsfaFlame 1.5s ease-in-out infinite;transform-origin:50% 85%}@keyframes bsfaFlame{0%,100%{transform:scale(1) rotate(-5deg)}50%{transform:scale(1.25) rotate(6deg)}}.bsfa-salebar__txt{font-size:13.5px;font-weight:600;color:#cfe3ff}.bsfa-salebar__cd{display:inline-flex;align-items:center;gap:5px}.bsfa-salebar__cd b{background:rgba(125,211,252,.12);border:1px solid rgba(125,211,252,.42);border-radius:7px;padding:3px 7px;font-size:14px;font-weight:800;min-width:26px;text-align:center;font-variant-numeric:tabular-nums;color:#fff}.bsfa-salebar__cd i{font-style:normal;font-size:10px;opacity:.8;margin-right:3px;text-transform:uppercase;letter-spacing:.03em;color:#bcd7f7}.bsfa-salebar__btn{background:linear-gradient(135deg,#f97316,#ef4444);color:#fff;font-weight:900;font-size:13.5px;padding:8px 20px;border-radius:999px;white-space:nowrap;box-shadow:0 6px 16px rgba(239,68,68,.45);transition:transform .15s,box-shadow .15s}.bsfa-salebar__btn:hover{transform:translateY(-1px) scale(1.03);box-shadow:0 8px 22px rgba(239,68,68,.6);color:#fff}@media(max-width:767px){.bsfa-salebar__in{gap:9px;padding:8px 12px}.bsfa-salebar__txt{display:none}.bsfa-salebar__tag{font-size:12.5px;padding:5px 12px}.bsfa-salebar__cd b{padding:2px 5px;font-size:12.5px;min-width:22px}.bsfa-salebar__cd i{font-size:9px}.bsfa-salebar__btn{font-size:12.5px;padding:7px 14px}}';
    document.head.appendChild(st);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('bsfa-revealed'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    var i = 0;
    function scan() {
      var els = document.querySelectorAll('.m-product-card, .bwh-card, .bsfa-why__box, .l4y-fcard, .imp-card, .bf-q');
      els.forEach(function (el) {
        if (el.__bsfaRev) return;
        el.__bsfaRev = 1;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) return;
        el.classList.add('bsfa-will-reveal');
        el.style.transitionDelay = ((i % 4) * 70) + 'ms';
        i++;
        io.observe(el);
      });
    }
    scan();
    document.addEventListener('DOMContentLoaded', scan);
    window.addEventListener('load', scan);
    var mo = new MutationObserver(function () { scan(); });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  })();


  /* ============================================================
     POPUP DI BENVENUTO — 5% con BULK5, mostrato una sola volta
     ============================================================ */
  (function () {
    var KEY = 'bsfaPromo1';
    try { if (window.localStorage && localStorage.getItem(KEY)) return; } catch (err) { return; }
    function mark() { try { localStorage.setItem(KEY, '1'); } catch (err) {} }
    function show() {
      if (BSFA_isPwd()) return;
      if (document.getElementById('bsfa-promo-ov')) return;
      if (!document.body) return;
      var dialogAria = BSFA_t('welcome.dialog_aria', 'Willkommensrabatt');
      var closeAria = BSFA_t('welcome.close_aria', 'Schließen');
      var title = BSFA_t('welcome.title', 'Willkommen bei BulkShopForAll!');
      var bodyHtml = BSFA_t('welcome.body_html', 'Sichern Sie sich <b>5% Rabatt</b> auf viele Produkte im Katalog – einfach diesen Code an der Kasse eingeben:');
      var codeTitle = BSFA_t('welcome.code_title', 'Klicken zum Kopieren');
      var copyLabel = BSFA_t('welcome.copy_label', 'Kopieren');
      var cta = BSFA_t('welcome.cta', '🎉 5% aktivieren & shoppen');
      var tip = BSFA_t('welcome.tip', '💡 Tipp: Ab 10 Lizenzen erhalten Sie zusätzlich automatisch 10% Mengenrabatt.');
      var root = BSFA_root();
      var homeHref = root + '/';
      var discountHref = root + '/discount/BULK5?redirect=' + encodeURIComponent(homeHref);
      var ov = document.createElement('div');
      ov.id = 'bsfa-promo-ov';
      ov.innerHTML =
        '<div class="bsfa-promo" role="dialog" aria-modal="true" aria-label="' + dialogAria + '">' +
          '<button type="button" class="bsfa-promo__x" aria-label="' + closeAria + '">×</button>' +
          '<div class="bsfa-promo__gift">🎁</div>' +
          '<h3>' + title + '</h3>' +
          '<p>' + bodyHtml + '</p>' +
          '<div class="bsfa-promo__code" title="' + codeTitle + '"><span>BULK5</span><em>' + copyLabel + '</em></div>' +
          '<a class="bsfa-promo__cta" href="' + discountHref + '">' + cta + '</a>' +
          '<small>' + tip + '</small>' +
        '</div>';
      document.body.appendChild(ov);
      function close() { mark(); if (ov.parentNode) ov.parentNode.removeChild(ov); }
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      ov.querySelector('.bsfa-promo__x').addEventListener('click', close);
      ov.querySelector('.bsfa-promo__cta').addEventListener('click', mark);
      document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
      var codeEl = ov.querySelector('.bsfa-promo__code');
      codeEl.addEventListener('click', function () {
        var copiedLabel = BSFA_t('welcome.copied_label', 'Kopiert ✓');
        var done = function () { codeEl.querySelector('em').textContent = copiedLabel; };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText('BULK5').then(done, done); }
        else { done(); }
      });
    }
    if (document.readyState === 'complete') show();
    else window.addEventListener('load', show);
  })();

  /* ---- Sale bar con countdown (data di fine fissa) ---- */
  (function () {
    if (document.getElementById('bsfa-salebar')) return;
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function nextDeadline(){
      // BSFA: Grand Opening Sale — data di fine FISSA: 17 settembre 2026 23:59:59
      // (parte il 19 luglio 2026, dura 60 giorni). Mese 0-based: 8 = settembre.
      return new Date(2026, 8, 17, 23, 59, 59);
    }
    function build(){
      if (BSFA_isPwd()) return;
      /* BSFA: se la scadenza FISSA e' gia' passata non mostrare nulla (mai zeri, mai urgenza falsa). */
      if (nextDeadline() - new Date() <= 0) return;
      var tag = BSFA_t('salebar.tag', 'Eröffnungs-Sale');
      var text = BSFA_t('salebar.text', 'Die besten Preise des Jahres — nur für kurze Zeit');
      var aria = BSFA_t('salebar.aria', 'Angebot endet in');
      var dLbl = BSFA_t('salebar.days', 'Tage');
      var hLbl = BSFA_t('salebar.hrs', 'Std');
      var mLbl = BSFA_t('salebar.mins', 'Min');
      var sLbl = BSFA_t('salebar.secs', 'Sek');
      var cta = BSFA_t('salebar.cta', 'Jetzt ansehen');
      var angeboteHref = (window.BSFA_URLS && window.BSFA_URLS.angebote) || (BSFA_root() + '/pages/angebote');
      var bar = document.createElement('div');
      bar.id = 'bsfa-salebar';
      bar.className = 'bsfa-salebar';
      bar.innerHTML =
        '<div class="bsfa-salebar__in">' +
          '<span class="bsfa-salebar__tag"><i class="bsfa-salebar__flame">🔥</i>' + tag + '</span>' +
          '<span class="bsfa-salebar__txt">' + text + '</span>' +
          '<span class="bsfa-salebar__cd" aria-label="' + aria + '">' +
            '<b data-d></b><i>' + dLbl + '</i><b data-h></b><i>' + hLbl + '</i><b data-m></b><i>' + mLbl + '</i><b data-s></b><i>' + sLbl + '</i>' +
          '</span>' +
          '<a class="bsfa-salebar__btn" href="' + angeboteHref + '">' + cta + '</a>' +
        '</div>';
      var body = document.body;
      body.insertBefore(bar, body.firstChild);
      var end = nextDeadline();
      var dd = bar.querySelector('[data-d]'), hh = bar.querySelector('[data-h]'),
          mm = bar.querySelector('[data-m]'), ss = bar.querySelector('[data-s]');
      var timer = null;
      function tick(){
        var now = new Date(), diff = Math.floor((end - now) / 1000);
        if (diff <= 0){
          if (timer) { clearInterval(timer); timer = null; }
          if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
          return;
        }
        var days = Math.floor(diff / 86400); diff -= days * 86400;
        var h = Math.floor(diff / 3600); diff -= h * 3600;
        var m = Math.floor(diff / 60); var s = diff - m * 60;
        dd.textContent = pad(days); hh.textContent = pad(h); mm.textContent = pad(m); ss.textContent = pad(s);
      }
      tick(); timer = setInterval(tick, 1000);
    }
    /* BSFA: countdown riattivato. La scadenza e' FISSA e reale (17/09/2026 23:59:59) e NON si riazzera:
       non comunica quindi un'urgenza non verificabile. Alla scadenza la barra si rimuove da sola,
       senza mostrare zeri. Le etichette arrivano da window.BSFA_I18N.salebar (tutte le lingue). */
    if (document.body) build();
    else document.addEventListener('DOMContentLoaded', build);
  })();

})();